/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
  class FreeShippingProgressBar extends HTMLElement {
    constructor() {
      super();
      this.currentPercent = 0;
    }

    connectedCallback() {
      this.updateStatus();
    }

    formatCurrency(amount, withCurrency = false) {
      const fallbackFormat = withCurrency ? "${{amount}} USD" : "${{amount}}";
      const currencyFormat = withCurrency
        ? (window.theme?.settings?.money_with_currency_format || fallbackFormat)
        : (window.theme?.settings?.money_format || fallbackFormat);

      return formatMoney(amount, currencyFormat);
    }

    updateStatus() {
      const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      const freeShippingThreshold = Math.round(
        (parseInt(this.dataset.shippingAmount, 10) || 0) * (Shopify.currency.rate || 1)
      );
      const style = this.dataset.style || 'default';
      const isEligible = cartTotal >= freeShippingThreshold;
      const remainingAmount = Math.max(freeShippingThreshold - cartTotal, 0);

      if (style === 'alternative') {
        this.updateAlternativeState({
          remainingAmount,
          freeShippingThreshold,
          isEligible
        });
      } else {
        this.updateDefaultState({
          remainingAmount,
          isEligible
        });
      }

      const progressPercentage = freeShippingThreshold > 0
        ? (isEligible ? 1 : cartTotal / freeShippingThreshold)
        : 0;

      this.animateProgressBar(progressPercentage);
    }

    updateDefaultState({ remainingAmount, isEligible }) {
      const remainingAmountText = this.querySelector('.free-shipping__info-text strong');
      const remainingInfo = this.querySelector('.free-shipping__info-text');
      const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');

      if (remainingAmountText && !isEligible) {
        remainingAmountText.innerHTML = this.formatCurrency(remainingAmount, true);
      }

      if (remainingInfo) {
        remainingInfo.style.display = isEligible ? 'none' : 'block';
      }

      if (eligibilityInfo) {
        eligibilityInfo.style.display = isEligible ? 'block' : 'none';
      }
    }

    updateAlternativeState({ remainingAmount, freeShippingThreshold, isEligible }) {
      const thresholdInfo = this.querySelector('.free-shipping__alt-threshold');
      const remainingInfo = this.querySelector('.free-shipping__alt-remaining');

      if (thresholdInfo) {
        thresholdInfo.innerHTML = this.formatCurrency(freeShippingThreshold, true);
      }

      if (remainingInfo) {
        if (isEligible) {
          remainingInfo.textContent = 'Free shipping unlocked';
        } else {
          remainingInfo.innerHTML = `Only <span class="free-shipping__remaining-amount">${this.formatCurrency(remainingAmount, true)}</span> away`;
        }
      }
    }

    animateProgressBar(progressPercentage) {
      const targetPercent = progressPercentage * 100;
      const startPercent = this.currentPercent;
      const duration = 200;
      const startTime = performance.now();

      const ease = (t) => t * (2 - t);

      const animate = (time) => {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = ease(progress);

        this.currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
        this.style.setProperty('--percent', `${this.currentPercent}%`);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.currentPercent = targetPercent;
          this.style.setProperty('--percent', `${this.currentPercent}%`);
        }
      };

      requestAnimationFrame(animate);
    }
  }

  customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}